import { defineContent, type DefinedContent } from '@post-office/define-content';

/**
 * Content for the Rovo extension install CTA left-nav placement. The copy experiment shipped
 * copy-version-c, so there is a single set. Descriptors are written inline because values pulled
 * from a variable or spread are invisible to the i18n extractor.
 */
export const registeredContent: DefinedContent<{
	default: [
		'heading',
		'description',
		'linkText',
		'rovoIconAlt',
		'chromeIconAlt',
		'whyAmISeeingThisReason',
	];
}> = defineContent({
	default: {
		heading: {
			id: 'rovo-extension-install-cta-left-nav.heading.copy-version-c',
			defaultMessage: 'Unlock Rovo in every tab',
			description: 'Heading text for rovo extension install cta left nav',
			role: 'title',
		},
		description: {
			id: 'rovo-extension-install-cta-left-nav.description.copy-version-c',
			defaultMessage: '50K+ workers use it to chat with AI that understands their company.',
			description: 'Description text for rovo extension install cta left nav',
			role: 'description',
		},
		linkText: {
			id: 'rovo-extension-install-cta-left-nav.link',
			defaultMessage: 'Get the browser extension',
			description: 'Text for rovo extension install cta link left nav',
		},
		rovoIconAlt: {
			id: 'rovo-extension-install-cta-left-nav.rovo-icon-alt',
			defaultMessage: 'Rovo Icon',
			description: 'Alt text for Rovo icon image',
		},
		chromeIconAlt: {
			id: 'rovo-extension-install-cta-left-nav.chrome-icon-alt',
			defaultMessage: 'Google Chrome Icon',
			description: 'Alt text for Google Chrome icon image',
		},
		whyAmISeeingThisReason: {
			id: 'rovo-extension-install-cta-left-nav.why-am-i-seeing-this.reason-rovo-usage',
			defaultMessage: 'your past Rovo usage',
			description:
				'Reason shown as a bullet in the "Why am I seeing this?" modal for the Rovo browser extension install CTA. It follows the lead-in "We think you\'d find this relevant. This is based on:", so it is a lowercase fragment with no period. Rovo is a product name and is not translated.',
		},
	},
});
